module.exports = __webpack_public_path__ + "img/IMG_20210825_113947548.99dfa6e5.jpg";